import request from '@/config/axios'

export interface LiveCoinConfigVO {
  id?: number
  coinName?: string
  fenPerCoin?: number
  withdrawEnabled?: boolean
}

export interface LiveCoinRechargeVO {
  id?: number
  userId?: number
  coinAmount?: number
  payPrice?: number
  payStatus?: number
  payOrderId?: number
  tradeOrderId?: number
  payTime?: string
  createTime?: string
}

export interface LiveCoinWithdrawVO {
  id?: number
  userId?: number
  coinAmount?: number
  /** 0 待审核 1 待打款 2 已拒绝 3 已打款 */
  status?: number
  accountInfo?: string
  auditRemark?: string
  auditTime?: string
  payProofUrl?: string
  payRemark?: string
  payTime?: string
  createTime?: string
}

export const getConfig = () => request.get({ url: '/live/coin/config/get' })
export const saveConfig = (data: LiveCoinConfigVO) =>
  request.post({ url: '/live/coin/config/save', data })
export const rechargePage = (params: any) =>
  request.get({ url: '/live/coin/recharge/page', params })
export const withdrawPage = (params: any) =>
  request.get({ url: '/live/coin/withdraw/page', params })
export const auditWithdraw = (id: number, pass: boolean, remark?: string) =>
  request.put({ url: '/live/coin/withdraw/audit', params: { id, pass, remark } })
export const markWithdrawPaid = (data: {
  id: number
  payProofUrl: string
  payRemark?: string
}) => request.put({ url: '/live/coin/withdraw/mark-paid', data })
export const getMemberCoin = (userId: number) =>
  request.get({ url: '/live/coin/member/get', params: { userId } })
export const adjustMemberCoin = (data: { userId: number; coinDelta: number; remark?: string }) =>
  request.post({ url: '/live/coin/member/adjust', data })
